var Qt = (e) => {
  throw TypeError(e);
};
var gt = (e, t, s) => t.has(e) || Qt("Cannot " + s);
var i = (e, t, s) => (gt(e, t, "read from private field"), s ? s.call(e) : t.get(e)), l = (e, t, s) => t.has(e) ? Qt("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, s), h = (e, t, s, r) => (gt(e, t, "write to private field"), r ? r.call(e, s) : t.set(e, s), s), v = (e, t, s) => (gt(e, t, "access private method"), s);
var ft = (e, t, s, r) => ({
  set _(n) {
    h(e, t, n, s);
  },
  get _() {
    return i(e, t, r);
  }
});
import { r as X, j as G, R as $t } from "./client-BkmPNNjT.mjs.js";
const _t = X.createContext(null), bt = {
  didCatch: !1,
  error: null
};
class te extends X.Component {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = bt;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var s, r, n = arguments.length, a = new Array(n), c = 0; c < n; c++)
        a[c] = arguments[c];
      (s = (r = this.props).onReset) === null || s === void 0 || s.call(r, {
        args: a,
        reason: "imperative-api"
      }), this.setState(bt);
    }
  }
  componentDidCatch(t, s) {
    var r, n;
    (r = (n = this.props).onError) === null || r === void 0 || r.call(n, t, s);
  }
  componentDidUpdate(t, s) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: n
    } = this.props;
    if (r && s.error !== null && ee(t.resetKeys, n)) {
      var a, c;
      (a = (c = this.props).onReset) === null || a === void 0 || a.call(c, {
        next: n,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(bt);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: s,
      FallbackComponent: r,
      fallback: n
    } = this.props, {
      didCatch: a,
      error: c
    } = this.state;
    let u = t;
    if (a) {
      const o = {
        error: c,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof s == "function")
        u = s(o);
      else if (r)
        u = X.createElement(r, o);
      else if (n !== void 0)
        u = n;
      else
        throw c;
    }
    return X.createElement(_t.Provider, {
      value: {
        didCatch: a,
        error: c,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function ee() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((s, r) => !Object.is(s, t[r]));
}
var mt = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, se = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: (e) => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: (e) => clearInterval(e)
}, I, St, It, re = (It = class {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    l(this, I, se);
    l(this, St, !1);
  }
  setTimeoutProvider(e) {
    h(this, I, e);
  }
  setTimeout(e, t) {
    return i(this, I).setTimeout(e, t);
  }
  clearTimeout(e) {
    i(this, I).clearTimeout(e);
  }
  setInterval(e, t) {
    return i(this, I).setInterval(e, t);
  }
  clearInterval(e) {
    i(this, I).clearInterval(e);
  }
}, I = new WeakMap(), St = new WeakMap(), It), wt = new re();
function ie(e) {
  setTimeout(e, 0);
}
var vt = typeof window > "u" || "Deno" in globalThis;
function F() {
}
function ne(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ae(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function oe(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Ct(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ue(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Dt(e, t) {
  const {
    type: s = "all",
    exact: r,
    fetchStatus: n,
    predicate: a,
    queryKey: c,
    stale: u
  } = e;
  if (c) {
    if (r) {
      if (t.queryHash !== Ft(c, t.options))
        return !1;
    } else if (!ot(t.queryKey, c))
      return !1;
  }
  if (s !== "all") {
    const o = t.isActive();
    if (s === "active" && !o || s === "inactive" && o)
      return !1;
  }
  return !(typeof u == "boolean" && t.isStale() !== u || n && n !== t.state.fetchStatus || a && !a(t));
}
function qt(e, t) {
  const { exact: s, status: r, predicate: n, mutationKey: a } = e;
  if (a) {
    if (!t.options.mutationKey)
      return !1;
    if (s) {
      if (at(t.options.mutationKey) !== at(a))
        return !1;
    } else if (!ot(t.options.mutationKey, a))
      return !1;
  }
  return !(r && t.state.status !== r || n && !n(t));
}
function Ft(e, t) {
  return (t?.queryKeyHashFn || at)(e);
}
function at(e) {
  return JSON.stringify(
    e,
    (t, s) => Ot(s) ? Object.keys(s).sort().reduce((r, n) => (r[n] = s[n], r), {}) : s
  );
}
function ot(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every((s) => ot(e[s], t[s])) : !1;
}
var ce = Object.prototype.hasOwnProperty;
function zt(e, t) {
  if (e === t)
    return e;
  const s = At(e) && At(t);
  if (!s && !(Ot(e) && Ot(t))) return t;
  const n = (s ? e : Object.keys(e)).length, a = s ? t : Object.keys(t), c = a.length, u = s ? new Array(c) : {};
  let o = 0;
  for (let p = 0; p < c; p++) {
    const m = s ? p : a[p], C = e[m], S = t[m];
    if (C === S) {
      u[m] = C, (s ? p < n : ce.call(e, m)) && o++;
      continue;
    }
    if (C === null || S === null || typeof C != "object" || typeof S != "object") {
      u[m] = S;
      continue;
    }
    const j = zt(C, S);
    u[m] = j, j === C && o++;
  }
  return n === c && o === n ? e : u;
}
function xe(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const s in e)
    if (e[s] !== t[s])
      return !1;
  return !0;
}
function At(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Ot(e) {
  if (!xt(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const s = t.prototype;
  return !(!xt(s) || !s.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function xt(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function he(e) {
  return new Promise((t) => {
    wt.setTimeout(t, e);
  });
}
function le(e, t, s) {
  return typeof s.structuralSharing == "function" ? s.structuralSharing(e, t) : s.structuralSharing !== !1 ? zt(e, t) : t;
}
function Te(e) {
  return e;
}
function de(e, t, s = 0) {
  const r = [...e, t];
  return s && r.length > s ? r.slice(1) : r;
}
function fe(e, t, s = 0) {
  const r = [t, ...e];
  return s && r.length > s ? r.slice(0, -1) : r;
}
var Et = Symbol();
function Wt(e, t) {
  return !e.queryFn && t?.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === Et ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function je(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var N, K, Y, Kt, ye = (Kt = class extends mt {
  constructor() {
    super();
    l(this, N);
    l(this, K);
    l(this, Y);
    h(this, Y, (t) => {
      if (!vt && window.addEventListener) {
        const s = () => t();
        return window.addEventListener("visibilitychange", s, !1), () => {
          window.removeEventListener("visibilitychange", s);
        };
      }
    });
  }
  onSubscribe() {
    i(this, K) || this.setEventListener(i(this, Y));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = i(this, K)) == null || t.call(this), h(this, K, void 0));
  }
  setEventListener(t) {
    var s;
    h(this, Y, t), (s = i(this, K)) == null || s.call(this), h(this, K, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    i(this, N) !== t && (h(this, N, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((s) => {
      s(t);
    });
  }
  isFocused() {
    return typeof i(this, N) == "boolean" ? i(this, N) : globalThis.document?.visibilityState !== "hidden";
  }
}, N = new WeakMap(), K = new WeakMap(), Y = new WeakMap(), Kt), Vt = new ye();
function pe() {
  let e, t;
  const s = new Promise((n, a) => {
    e = n, t = a;
  });
  s.status = "pending", s.catch(() => {
  });
  function r(n) {
    Object.assign(s, n), delete s.resolve, delete s.reject;
  }
  return s.resolve = (n) => {
    r({
      status: "fulfilled",
      value: n
    }), e(n);
  }, s.reject = (n) => {
    r({
      status: "rejected",
      reason: n
    }), t(n);
  }, s;
}
var me = ie;
function ve() {
  let e = [], t = 0, s = (u) => {
    u();
  }, r = (u) => {
    u();
  }, n = me;
  const a = (u) => {
    t ? e.push(u) : n(() => {
      s(u);
    });
  }, c = () => {
    const u = e;
    e = [], u.length && n(() => {
      r(() => {
        u.forEach((o) => {
          s(o);
        });
      });
    });
  };
  return {
    batch: (u) => {
      let o;
      t++;
      try {
        o = u();
      } finally {
        t--, t || c();
      }
      return o;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (u) => (...o) => {
      a(() => {
        u(...o);
      });
    },
    schedule: a,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (u) => {
      s = u;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (u) => {
      r = u;
    },
    setScheduler: (u) => {
      n = u;
    }
  };
}
var w = ve(), $, U, _, Ut, ge = (Ut = class extends mt {
  constructor() {
    super();
    l(this, $, !0);
    l(this, U);
    l(this, _);
    h(this, _, (t) => {
      if (!vt && window.addEventListener) {
        const s = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", s, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", s), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    i(this, U) || this.setEventListener(i(this, _));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = i(this, U)) == null || t.call(this), h(this, U, void 0));
  }
  setEventListener(t) {
    var s;
    h(this, _, t), (s = i(this, U)) == null || s.call(this), h(this, U, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    i(this, $) !== t && (h(this, $, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return i(this, $);
  }
}, $ = new WeakMap(), U = new WeakMap(), _ = new WeakMap(), Ut), pt = new ge();
function be(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Jt(e) {
  return (e ?? "online") === "online" ? pt.isOnline() : !0;
}
var Pt = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e?.revert, this.silent = e?.silent;
  }
};
function Zt(e) {
  let t = !1, s = 0, r;
  const n = pe(), a = () => n.status !== "pending", c = (f) => {
    if (!a()) {
      const O = new Pt(f);
      S(O), e.onCancel?.(O);
    }
  }, u = () => {
    t = !0;
  }, o = () => {
    t = !1;
  }, p = () => Vt.isFocused() && (e.networkMode === "always" || pt.isOnline()) && e.canRun(), m = () => Jt(e.networkMode) && e.canRun(), C = (f) => {
    a() || (r?.(), n.resolve(f));
  }, S = (f) => {
    a() || (r?.(), n.reject(f));
  }, j = () => new Promise((f) => {
    r = (O) => {
      (a() || p()) && f(O);
    }, e.onPause?.();
  }).then(() => {
    r = void 0, a() || e.onContinue?.();
  }), g = () => {
    if (a())
      return;
    let f;
    const O = s === 0 ? e.initialPromise : void 0;
    try {
      f = O ?? e.fn();
    } catch (Q) {
      f = Promise.reject(Q);
    }
    Promise.resolve(f).then(C).catch((Q) => {
      if (a())
        return;
      const B = e.retry ?? (vt ? 0 : 3), nt = e.retryDelay ?? be, lt = typeof nt == "function" ? nt(s, Q) : nt, dt = B === !0 || typeof B == "number" && s < B || typeof B == "function" && B(s, Q);
      if (t || !dt) {
        S(Q);
        return;
      }
      s++, e.onFail?.(s, Q), he(lt).then(() => p() ? void 0 : j()).then(() => {
        t ? S(Q) : g();
      });
    });
  };
  return {
    promise: n,
    status: () => n.status,
    cancel: c,
    continue: () => (r?.(), n),
    cancelRetry: u,
    continueRetry: o,
    canStart: m,
    start: () => (m() ? g() : j().then(g), n)
  };
}
var z, kt, Xt = (kt = class {
  constructor() {
    l(this, z);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), ae(this.gcTime) && h(this, z, wt.setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (vt ? 1 / 0 : 300 * 1e3)
    );
  }
  clearGcTimeout() {
    i(this, z) && (wt.clearTimeout(i(this, z)), h(this, z, void 0));
  }
}, z = new WeakMap(), kt), W, tt, P, V, y, ut, J, E, x, Lt, we = (Lt = class extends Xt {
  constructor(t) {
    super();
    l(this, E);
    l(this, W);
    l(this, tt);
    l(this, P);
    l(this, V);
    l(this, y);
    l(this, ut);
    l(this, J);
    h(this, J, !1), h(this, ut, t.defaultOptions), this.setOptions(t.options), this.observers = [], h(this, V, t.client), h(this, P, i(this, V).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, h(this, W, Tt(this.options)), this.state = t.state ?? i(this, W), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    return i(this, y)?.promise;
  }
  setOptions(t) {
    if (this.options = { ...i(this, ut), ...t }, this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
      const s = Tt(this.options);
      s.data !== void 0 && (this.setData(s.data, {
        updatedAt: s.dataUpdatedAt,
        manual: !0
      }), h(this, W, s));
    }
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && i(this, P).remove(this);
  }
  setData(t, s) {
    const r = le(this.state.data, t, this.options);
    return v(this, E, x).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: s?.updatedAt,
      manual: s?.manual
    }), r;
  }
  setState(t, s) {
    v(this, E, x).call(this, { type: "setState", state: t, setStateOptions: s });
  }
  cancel(t) {
    const s = i(this, y)?.promise;
    return i(this, y)?.cancel(t), s ? s.then(F).catch(F) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(i(this, W));
  }
  isActive() {
    return this.observers.some(
      (t) => ue(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Et || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => Ct(t.options.staleTime, this) === "static"
    ) : !1;
  }
  isStale() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(t = 0) {
    return this.state.data === void 0 ? !0 : t === "static" ? !1 : this.state.isInvalidated ? !0 : !oe(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    this.observers.find((s) => s.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), i(this, y)?.continue();
  }
  onOnline() {
    this.observers.find((s) => s.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), i(this, y)?.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), i(this, P).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((s) => s !== t), this.observers.length || (i(this, y) && (i(this, J) ? i(this, y).cancel({ revert: !0 }) : i(this, y).cancelRetry()), this.scheduleGc()), i(this, P).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || v(this, E, x).call(this, { type: "invalidate" });
  }
  async fetch(t, s) {
    if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
    // re-start the fetch; there is a chance that the query is still in a
    // pending state when that happens
    i(this, y)?.status() !== "rejected") {
      if (this.state.data !== void 0 && s?.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (i(this, y))
        return i(this, y).continueRetry(), i(this, y).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const o = this.observers.find((p) => p.options.queryFn);
      o && this.setOptions(o.options);
    }
    const r = new AbortController(), n = (o) => {
      Object.defineProperty(o, "signal", {
        enumerable: !0,
        get: () => (h(this, J, !0), r.signal)
      });
    }, a = () => {
      const o = Wt(this.options, s), m = (() => {
        const C = {
          client: i(this, V),
          queryKey: this.queryKey,
          meta: this.meta
        };
        return n(C), C;
      })();
      return h(this, J, !1), this.options.persister ? this.options.persister(
        o,
        m,
        this
      ) : o(m);
    }, u = (() => {
      const o = {
        fetchOptions: s,
        options: this.options,
        queryKey: this.queryKey,
        client: i(this, V),
        state: this.state,
        fetchFn: a
      };
      return n(o), o;
    })();
    this.options.behavior?.onFetch(u, this), h(this, tt, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== u.fetchOptions?.meta) && v(this, E, x).call(this, { type: "fetch", meta: u.fetchOptions?.meta }), h(this, y, Zt({
      initialPromise: s?.initialPromise,
      fn: u.fetchFn,
      onCancel: (o) => {
        o instanceof Pt && o.revert && this.setState({
          ...i(this, tt),
          fetchStatus: "idle"
        }), r.abort();
      },
      onFail: (o, p) => {
        v(this, E, x).call(this, { type: "failed", failureCount: o, error: p });
      },
      onPause: () => {
        v(this, E, x).call(this, { type: "pause" });
      },
      onContinue: () => {
        v(this, E, x).call(this, { type: "continue" });
      },
      retry: u.options.retry,
      retryDelay: u.options.retryDelay,
      networkMode: u.options.networkMode,
      canRun: () => !0
    }));
    try {
      const o = await i(this, y).start();
      if (o === void 0)
        throw new Error(`${this.queryHash} data is undefined`);
      return this.setData(o), i(this, P).config.onSuccess?.(o, this), i(this, P).config.onSettled?.(
        o,
        this.state.error,
        this
      ), o;
    } catch (o) {
      if (o instanceof Pt) {
        if (o.silent)
          return i(this, y).promise;
        if (o.revert) {
          if (this.state.data === void 0)
            throw o;
          return this.state.data;
        }
      }
      throw v(this, E, x).call(this, {
        type: "error",
        error: o
      }), i(this, P).config.onError?.(
        o,
        this
      ), i(this, P).config.onSettled?.(
        this.state.data,
        o,
        this
      ), o;
    } finally {
      this.scheduleGc();
    }
  }
}, W = new WeakMap(), tt = new WeakMap(), P = new WeakMap(), V = new WeakMap(), y = new WeakMap(), ut = new WeakMap(), J = new WeakMap(), E = new WeakSet(), x = function(t) {
  const s = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...Ce(r.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        const n = {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
        return h(this, tt, t.manual ? n : void 0), n;
      case "error":
        const a = t.error;
        return {
          ...r,
          error: a,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: a,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = s(this.state), w.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), i(this, P).notify({ query: this, type: "updated", action: t });
  });
}, Lt);
function Ce(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Jt(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Tt(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, s = t !== void 0, r = s ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: s ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: s ? "success" : "pending",
    fetchStatus: "idle"
  };
}
function jt(e) {
  return {
    onFetch: (t, s) => {
      const r = t.options, n = t.fetchOptions?.meta?.fetchMore?.direction, a = t.state.data?.pages || [], c = t.state.data?.pageParams || [];
      let u = { pages: [], pageParams: [] }, o = 0;
      const p = async () => {
        let m = !1;
        const C = (g) => {
          Object.defineProperty(g, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? m = !0 : t.signal.addEventListener("abort", () => {
              m = !0;
            }), t.signal)
          });
        }, S = Wt(t.options, t.fetchOptions), j = async (g, f, O) => {
          if (m)
            return Promise.reject();
          if (f == null && g.pages.length)
            return Promise.resolve(g);
          const B = (() => {
            const Mt = {
              client: t.client,
              queryKey: t.queryKey,
              pageParam: f,
              direction: O ? "backward" : "forward",
              meta: t.options.meta
            };
            return C(Mt), Mt;
          })(), nt = await S(B), { maxPages: lt } = t.options, dt = O ? fe : de;
          return {
            pages: dt(g.pages, nt, lt),
            pageParams: dt(g.pageParams, f, lt)
          };
        };
        if (n && a.length) {
          const g = n === "backward", f = g ? Oe : Rt, O = {
            pages: a,
            pageParams: c
          }, Q = f(r, O);
          u = await j(O, Q, g);
        } else {
          const g = e ?? a.length;
          do {
            const f = o === 0 ? c[0] ?? r.initialPageParam : Rt(r, u);
            if (o > 0 && f == null)
              break;
            u = await j(u, f), o++;
          } while (o < g);
        }
        return u;
      };
      t.options.persister ? t.fetchFn = () => t.options.persister?.(
        p,
        {
          client: t.client,
          queryKey: t.queryKey,
          meta: t.options.meta,
          signal: t.signal
        },
        s
      ) : t.fetchFn = p;
    }
  };
}
function Rt(e, { pages: t, pageParams: s }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    s[r],
    s
  ) : void 0;
}
function Oe(e, { pages: t, pageParams: s }) {
  return t.length > 0 ? e.getPreviousPageParam?.(t[0], t, s[0], s) : void 0;
}
var ct, D, b, Z, q, R, Ht, Pe = (Ht = class extends Xt {
  constructor(t) {
    super();
    l(this, q);
    l(this, ct);
    l(this, D);
    l(this, b);
    l(this, Z);
    h(this, ct, t.client), this.mutationId = t.mutationId, h(this, b, t.mutationCache), h(this, D, []), this.state = t.state || Se(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    i(this, D).includes(t) || (i(this, D).push(t), this.clearGcTimeout(), i(this, b).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    h(this, D, i(this, D).filter((s) => s !== t)), this.scheduleGc(), i(this, b).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    i(this, D).length || (this.state.status === "pending" ? this.scheduleGc() : i(this, b).remove(this));
  }
  continue() {
    return i(this, Z)?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    const s = () => {
      v(this, q, R).call(this, { type: "continue" });
    }, r = {
      client: i(this, ct),
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    h(this, Z, Zt({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t, r) : Promise.reject(new Error("No mutationFn found")),
      onFail: (c, u) => {
        v(this, q, R).call(this, { type: "failed", failureCount: c, error: u });
      },
      onPause: () => {
        v(this, q, R).call(this, { type: "pause" });
      },
      onContinue: s,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => i(this, b).canRun(this)
    }));
    const n = this.state.status === "pending", a = !i(this, Z).canStart();
    try {
      if (n)
        s();
      else {
        v(this, q, R).call(this, { type: "pending", variables: t, isPaused: a }), await i(this, b).config.onMutate?.(
          t,
          this,
          r
        );
        const u = await this.options.onMutate?.(
          t,
          r
        );
        u !== this.state.context && v(this, q, R).call(this, {
          type: "pending",
          context: u,
          variables: t,
          isPaused: a
        });
      }
      const c = await i(this, Z).start();
      return await i(this, b).config.onSuccess?.(
        c,
        t,
        this.state.context,
        this,
        r
      ), await this.options.onSuccess?.(
        c,
        t,
        this.state.context,
        r
      ), await i(this, b).config.onSettled?.(
        c,
        null,
        this.state.variables,
        this.state.context,
        this,
        r
      ), await this.options.onSettled?.(
        c,
        null,
        t,
        this.state.context,
        r
      ), v(this, q, R).call(this, { type: "success", data: c }), c;
    } catch (c) {
      try {
        throw await i(this, b).config.onError?.(
          c,
          t,
          this.state.context,
          this,
          r
        ), await this.options.onError?.(
          c,
          t,
          this.state.context,
          r
        ), await i(this, b).config.onSettled?.(
          void 0,
          c,
          this.state.variables,
          this.state.context,
          this,
          r
        ), await this.options.onSettled?.(
          void 0,
          c,
          t,
          this.state.context,
          r
        ), c;
      } finally {
        v(this, q, R).call(this, { type: "error", error: c });
      }
    } finally {
      i(this, b).runNext(this);
    }
  }
}, ct = new WeakMap(), D = new WeakMap(), b = new WeakMap(), Z = new WeakMap(), q = new WeakSet(), R = function(t) {
  const s = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = s(this.state), w.batch(() => {
    i(this, D).forEach((r) => {
      r.onMutationUpdate(t);
    }), i(this, b).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, Ht);
function Se() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var T, M, ht, Bt, Fe = (Bt = class extends mt {
  constructor(t = {}) {
    super();
    l(this, T);
    l(this, M);
    l(this, ht);
    this.config = t, h(this, T, /* @__PURE__ */ new Set()), h(this, M, /* @__PURE__ */ new Map()), h(this, ht, 0);
  }
  build(t, s, r) {
    const n = new Pe({
      client: t,
      mutationCache: this,
      mutationId: ++ft(this, ht)._,
      options: t.defaultMutationOptions(s),
      state: r
    });
    return this.add(n), n;
  }
  add(t) {
    i(this, T).add(t);
    const s = yt(t);
    if (typeof s == "string") {
      const r = i(this, M).get(s);
      r ? r.push(t) : i(this, M).set(s, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (i(this, T).delete(t)) {
      const s = yt(t);
      if (typeof s == "string") {
        const r = i(this, M).get(s);
        if (r)
          if (r.length > 1) {
            const n = r.indexOf(t);
            n !== -1 && r.splice(n, 1);
          } else r[0] === t && i(this, M).delete(s);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const s = yt(t);
    if (typeof s == "string") {
      const n = i(this, M).get(s)?.find(
        (a) => a.state.status === "pending"
      );
      return !n || n === t;
    } else
      return !0;
  }
  runNext(t) {
    const s = yt(t);
    return typeof s == "string" ? i(this, M).get(s)?.find((n) => n !== t && n.state.isPaused)?.continue() ?? Promise.resolve() : Promise.resolve();
  }
  clear() {
    w.batch(() => {
      i(this, T).forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), i(this, T).clear(), i(this, M).clear();
    });
  }
  getAll() {
    return Array.from(i(this, T));
  }
  find(t) {
    const s = { exact: !0, ...t };
    return this.getAll().find(
      (r) => qt(s, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((s) => qt(t, s));
  }
  notify(t) {
    w.batch(() => {
      this.listeners.forEach((s) => {
        s(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((s) => s.state.isPaused);
    return w.batch(
      () => Promise.all(
        t.map((s) => s.continue().catch(F))
      )
    );
  }
}, T = new WeakMap(), M = new WeakMap(), ht = new WeakMap(), Bt);
function yt(e) {
  return e.options.scope?.id;
}
var A, Gt, Ee = (Gt = class extends mt {
  constructor(t = {}) {
    super();
    l(this, A);
    this.config = t, h(this, A, /* @__PURE__ */ new Map());
  }
  build(t, s, r) {
    const n = s.queryKey, a = s.queryHash ?? Ft(n, s);
    let c = this.get(a);
    return c || (c = new we({
      client: t,
      queryKey: n,
      queryHash: a,
      options: t.defaultQueryOptions(s),
      state: r,
      defaultOptions: t.getQueryDefaults(n)
    }), this.add(c)), c;
  }
  add(t) {
    i(this, A).has(t.queryHash) || (i(this, A).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const s = i(this, A).get(t.queryHash);
    s && (t.destroy(), s === t && i(this, A).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    w.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return i(this, A).get(t);
  }
  getAll() {
    return [...i(this, A).values()];
  }
  find(t) {
    const s = { exact: !0, ...t };
    return this.getAll().find(
      (r) => Dt(s, r)
    );
  }
  findAll(t = {}) {
    const s = this.getAll();
    return Object.keys(t).length > 0 ? s.filter((r) => Dt(t, r)) : s;
  }
  notify(t) {
    w.batch(() => {
      this.listeners.forEach((s) => {
        s(t);
      });
    });
  }
  onFocus() {
    w.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    w.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, A = new WeakMap(), Gt), d, k, L, et, st, H, rt, it, Nt, Me = (Nt = class {
  constructor(e = {}) {
    l(this, d);
    l(this, k);
    l(this, L);
    l(this, et);
    l(this, st);
    l(this, H);
    l(this, rt);
    l(this, it);
    h(this, d, e.queryCache || new Ee()), h(this, k, e.mutationCache || new Fe()), h(this, L, e.defaultOptions || {}), h(this, et, /* @__PURE__ */ new Map()), h(this, st, /* @__PURE__ */ new Map()), h(this, H, 0);
  }
  mount() {
    ft(this, H)._++, i(this, H) === 1 && (h(this, rt, Vt.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), i(this, d).onFocus());
    })), h(this, it, pt.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), i(this, d).onOnline());
    })));
  }
  unmount() {
    var e, t;
    ft(this, H)._--, i(this, H) === 0 && ((e = i(this, rt)) == null || e.call(this), h(this, rt, void 0), (t = i(this, it)) == null || t.call(this), h(this, it, void 0));
  }
  isFetching(e) {
    return i(this, d).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return i(this, k).findAll({ ...e, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(e) {
    const t = this.defaultQueryOptions({ queryKey: e });
    return i(this, d).get(t.queryHash)?.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), s = i(this, d).build(this, t), r = s.state.data;
    return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && s.isStaleByTime(Ct(t.staleTime, s)) && this.prefetchQuery(t), Promise.resolve(r));
  }
  getQueriesData(e) {
    return i(this, d).findAll(e).map(({ queryKey: t, state: s }) => {
      const r = s.data;
      return [t, r];
    });
  }
  setQueryData(e, t, s) {
    const r = this.defaultQueryOptions({ queryKey: e }), a = i(this, d).get(
      r.queryHash
    )?.state.data, c = ne(t, a);
    if (c !== void 0)
      return i(this, d).build(this, r).setData(c, { ...s, manual: !0 });
  }
  setQueriesData(e, t, s) {
    return w.batch(
      () => i(this, d).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, s)
      ])
    );
  }
  getQueryState(e) {
    const t = this.defaultQueryOptions({ queryKey: e });
    return i(this, d).get(
      t.queryHash
    )?.state;
  }
  removeQueries(e) {
    const t = i(this, d);
    w.batch(() => {
      t.findAll(e).forEach((s) => {
        t.remove(s);
      });
    });
  }
  resetQueries(e, t) {
    const s = i(this, d);
    return w.batch(() => (s.findAll(e).forEach((r) => {
      r.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...e
      },
      t
    )));
  }
  cancelQueries(e, t = {}) {
    const s = { revert: !0, ...t }, r = w.batch(
      () => i(this, d).findAll(e).map((n) => n.cancel(s))
    );
    return Promise.all(r).then(F).catch(F);
  }
  invalidateQueries(e, t = {}) {
    return w.batch(() => (i(this, d).findAll(e).forEach((s) => {
      s.invalidate();
    }), e?.refetchType === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...e,
        type: e?.refetchType ?? e?.type ?? "active"
      },
      t
    )));
  }
  refetchQueries(e, t = {}) {
    const s = {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }, r = w.batch(
      () => i(this, d).findAll(e).filter((n) => !n.isDisabled() && !n.isStatic()).map((n) => {
        let a = n.fetch(void 0, s);
        return s.throwOnError || (a = a.catch(F)), n.state.fetchStatus === "paused" ? Promise.resolve() : a;
      })
    );
    return Promise.all(r).then(F);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const s = i(this, d).build(this, t);
    return s.isStaleByTime(
      Ct(t.staleTime, s)
    ) ? s.fetch(t) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(F).catch(F);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = jt(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(F).catch(F);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = jt(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return pt.isOnline() ? i(this, k).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return i(this, d);
  }
  getMutationCache() {
    return i(this, k);
  }
  getDefaultOptions() {
    return i(this, L);
  }
  setDefaultOptions(e) {
    h(this, L, e);
  }
  setQueryDefaults(e, t) {
    i(this, et).set(at(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...i(this, et).values()], s = {};
    return t.forEach((r) => {
      ot(e, r.queryKey) && Object.assign(s, r.defaultOptions);
    }), s;
  }
  setMutationDefaults(e, t) {
    i(this, st).set(at(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...i(this, st).values()], s = {};
    return t.forEach((r) => {
      ot(e, r.mutationKey) && Object.assign(s, r.defaultOptions);
    }), s;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...i(this, L).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Ft(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Et && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e?._defaulted ? e : {
      ...i(this, L).mutations,
      ...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    i(this, d).clear(), i(this, k).clear();
  }
}, d = new WeakMap(), k = new WeakMap(), L = new WeakMap(), et = new WeakMap(), st = new WeakMap(), H = new WeakMap(), rt = new WeakMap(), it = new WeakMap(), Nt), Yt = X.createContext(
  void 0
), Re = (e) => {
  const t = X.useContext(Yt);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, Qe = ({
  client: e,
  children: t
}) => (X.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ G.jsx(Yt.Provider, { value: e, children: t }));
const De = new Me();
function Ie({
  children: e
}) {
  return /* @__PURE__ */ G.jsx($t.StrictMode, {
    children: /* @__PURE__ */ G.jsx(te, {
      fallbackRender: ({
        error: t
      }) => /* @__PURE__ */ G.jsxs("div", {
        className: "p-6",
        children: [/* @__PURE__ */ G.jsx("h1", {
          className: "text-3xl font-bold text-red-600 mb-4",
          children: t.status ? `${t.status} ${t.statusText}` : "Oops! Something went wrong"
        }), /* @__PURE__ */ G.jsx("p", {
          className: "text-gray-600 mb-6",
          children: t.message ?? "An unexpected error occurred. Please try again later."
        })]
      }),
      children: /* @__PURE__ */ G.jsx(Qe, {
        client: De,
        children: e
      })
    })
  });
}
export {
  Ie as L,
  mt as S,
  Ct as a,
  ae as b,
  wt as c,
  Ce as d,
  le as e,
  Vt as f,
  w as g,
  je as h,
  vt as i,
  Te as k,
  F as n,
  pe as p,
  ue as r,
  xe as s,
  oe as t,
  Re as u
};
